import { MultiLanguageString } from '@/lib/api/stays/types/shared-types'
import { stListingAmenitiesRepository } from '@/repositories/StListingAmenitiesRepo'
import { useQuery } from '@tanstack/react-query'

export interface IStListingAmenities {
  _mstitle: MultiLanguageString
  id: string
  stays_id: string
  category: string
}

export interface FormCheckboxGroupGroups {
  title: string
  items: {
    id: string
    stays_id: string
    name: string
  }[]
}

export const useStaysListingAmenities = () => {
  const {
    data: stListingAmenities,
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: ['st_listing_amenities'],
    queryFn: () => stListingAmenitiesRepository.getAll(),
  })

  return {
    stListingAmenities: stListingAmenities ?? [],
    isLoading,
    error,
    refetch,
  }
}
